import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import Wordmark from '../Brand/Wordmark';

interface ProtectedRouteProps {
  children: React.ReactNode;
  userType?: string;
}

/*
 * Velaigal protected route. The loading state is rendered before any
 * Layout chrome, so it must carry the brand on its own — cream surface,
 * editorial label, hairline-strong rule, no Material gray spinner.
 */
const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, userType }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen w-full bg-cream flex items-center justify-center px-8">
        <div className="text-center max-w-xs">
          <Wordmark variant="wordmark" size="sm" />
          <span aria-hidden="true" className="velaigal-loader-rule mx-auto mt-4 w-12" />
          <p className="mt-6 text-sm text-ink-tertiary">Signing you in.</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (userType && user.userType !== userType) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
